import React, { useState, useEffect } from "react";
import { Button, Typography, Grid, Container, TextField } from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import api from "../../globals/axios";
import {
  SERVER_BASE_ADDRESS,
  WAREHOUSE_TYPE_CONVENTION,
  AGRI_COMMODITY_TYPE_CONVENTION,
  PRODUCT_TYPE_CONVENTION,
} from "../../globals/const";
import { getStorageEmissions } from "../../globals/emissions";
import { getWalletFromLocal } from "../../globals/authentication";
import { getBlockchainNodeUrl } from "../../globals/const";
import CustomAppBar from "../../components/AppBar";

const styles = {
  icon: {
    marginRight: 2,
  },
  mainContent: {
    // backgroundColor: palette.background.paper,
    padding: 0.25,
    paddingLeft: 0.5,
    paddingRight: 0.5,
    flexGrow: 1,
  },
  row: {
    item: true,
    container: true,
    spacing: 1,
    justify: "center",
  },
  fab: {
    position: "fixed",
    bottom: 2,
    left: 2,
  },
  fabRow: {},
  fundSelectorRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  buttonRow: {
    margin: "10px",
    display: "flex",
    justifyContent: "space-around",
  },
};

export default function CreateStorage() {
  const classes = styles;
  const [wallet, setWallet] = useState({});
  const [pendingTransfers, setPendingTransfers] = useState([]);
  const [initiatorWallet, setIntiatorWallet] = useState();
  const [storageType, setStorageType] = useState("");
  const [storageDate, setStorageDate] = useState("");
  const [productCount, setProductCount] = useState();
  const [token, setToken] = useState("");
  const [facility, setFacility] = useState("");
  const [walletBalances, setWalletBalances] = useState([{}]);
  const [facilityTokens, setFacilityTokens] = useState([{}]);
  const [electricity, setElectricity] = useState([]);
  const additionalEmissions = null;
  const [storageQuality, setStorageQuality] = useState("");
  const [emission, setEmission] = useState([]);
  console.log(walletBalances);

  const storageTypes = {
    Traditional: "traditional",
    "Cold Storage": "coldStorage",
  };

  useEffect(() => {
    /**Set wallet to wallet stored in session */

    const loadWallet = async () => {
      const w = await getWalletFromLocal();
      setWallet(w);
    };

    loadWallet();
  }, []);

  useEffect(() => {
    /**Load linked partners */
    const setData = async () => {
      const res = await api.get(
        `${SERVER_BASE_ADDRESS}/chain/pending-transfers`
      );
      setPendingTransfers(res.data.pending_transfers);
    };
    setData();
  }, []);

  useEffect(() => {
    api
      .get(
        getBlockchainNodeUrl() +
          "/get-balances?balance_type=ALL_TOKENS_IN_WALLET&wallet_address=" +
          wallet.address +
          "&token_type=" +
          PRODUCT_TYPE_CONVENTION
      )
      .then((res) => res.data.balance)
      .then((data) => {
        if (data[0]) {
          data.forEach((token) => {
            api
              .get(
                getBlockchainNodeUrl() +
                  "/get-token?token_code=" +
                  token.token_code
              )
              .then((res) => res.data)
              .then((attributes) => {
                token.carbon_emission = JSON.parse(
                  attributes.token_attributes
                ).carbon_emission;
                token.amount = attributes.amount_created;
              });
          });
          setWalletBalances(data);
        }
      });

    api
      .get(
        getBlockchainNodeUrl() +
          "/get-balances?balance_type=ALL_TOKENS_IN_WALLET&wallet_address=" +
          wallet.address +
          "&token_type=" +
          AGRI_COMMODITY_TYPE_CONVENTION
      )
      .then((res) => res.data.balance)
      .then((data) => {
        if (data[0]) {
          data.forEach((token) => {
            api
              .get(
                getBlockchainNodeUrl() +
                  "/get-token?token_code=" +
                  token.token_code
              )
              .then((res) => res.data)
              .then((attributes) => {
                token.carbon_emission = JSON.parse(
                  attributes.token_attributes
                ).carbon_emission;
                token.amount = token.balance;
                try {
                  token.quality = JSON.parse(
                    attributes.token_attributes
                  ).harvest_quality;
                } catch {
                  token.quality = JSON.parse(
                    attributes.token_attributes
                  ).production_quality;
                }
              });
          });
          setWalletBalances((previousBalances) =>
            previousBalances.concat(data)
          );
        }
      });
  }, [wallet]);

  useEffect(() => {
    api
      .get(
        getBlockchainNodeUrl() +
          "/get-balances?balance_type=ALL_TOKENS_IN_WALLET&wallet_address=" +
          wallet.address +
          "&token_type=" +
          WAREHOUSE_TYPE_CONVENTION
      )
      .then((res) => res.data.balance)
      .then((data) => {
        if (data[0]) {
          setFacilityTokens(data);
        }
      });
  }, [wallet]);

  useEffect(() => {
    // originalEmissions(token.parent_token_code)
    setEmission(getStorageEmissions(storageType, electricity));
  });

  const createNFT = async () => {
    const childTokenCode = `STORAGE${
      token.parent_token_code
    }${facility.toUpperCase()}`;
    const tokenAttributes = {
      warehouse_token: facility,
      parent_token: token.parent_token_code,
      amount_stored: productCount,
      storage_type: storageType,
      electricty: electricity,
      storage_quality: storageQuality === "" ? token.quality : storageQuality,
      storage_date: storageDate,
      carbon_emission: emission,
    };

    api
      .post(`${SERVER_BASE_ADDRESS}/chain/claim-token`, {
        initiator_wallet: initiatorWallet,
        parent_token_code: token.parent_token_code,
        child_token_code: childTokenCode,
        child_token_attributes: tokenAttributes,
      })
      .then((result) => {
        console.log(result);
        alert("Storage Created Successfully");
        window.open(".", "_self");
      })
      .catch((err) => {
        alert("Error - " + err.response.data.non_field_errors[0]);
      });
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div className={classes.mainContent}>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <Typography variant="h5">Create Storage</Typography>

            <FormControl fullWidth margin="normal">
              <InputLabel id="token-select-label">Storage Facility</InputLabel>
              <Select
                labelId="token-select-label"
                id="token-select"
                value={facility}
                label="Token to send"
                onChange={(e) => {
                  setFacility(e.target.value);
                }}
              >
                {facilityTokens.map((b) => (
                  <MenuItem key={b.token_code} value={b.token_code}>
                    {b.token_code}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="token-select-label">Token to claim</InputLabel>
              <Select
                labelId="token-select-label"
                id="token-select"
                value={token.parent_token_code}
                label="Token to send"
                onChange={(e) => {
                  setToken(e.target.value);
                  setIntiatorWallet(e.target.value.initiator_wallet);
                  setProductCount(e.target.value.transfer_amount);
                }}
              >
                {pendingTransfers.map((transfer) => (
                  <MenuItem key={transfer.parent_token_code} value={transfer}>
                    {transfer.parent_token_code}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              required
              fullWidth
              name="txtamount"
              label={productCount ? "" : "Quantity"}
              type="numeric"
              id="txtamount"
              value={productCount}
              InputProps={{
                readOnly: true,
                disableUnderline: true,
                style: { pointerEvents: "none" },
              }}
              // onChange={event => setQuantity(roundDec(parseFloat(event.target.value)))} HAVE TO ACCEPT ALL OF CONTRACT TOKENS
            />

            <FormControl fullWidth sx={{ marginTop: 2 }}>
              <InputLabel id="storage-type-select-label">
                Storage Type
              </InputLabel>
              <Select
                labelId="storage-type-select-label"
                id="storage-type-select"
                value={storageType}
                label="Storage Type"
                onChange={(e) => {
                  setStorageType(e.target.value);
                  if (e.target.value === "traditional") setElectricity(0);
                  setEmission(
                    getStorageEmissions(
                      e.target.value,
                      electricity,
                      additionalEmissions
                    )
                  );
                }}
              >
                {Object.keys(storageTypes).map((type_key) => (
                  <MenuItem key={type_key} value={storageTypes[type_key]}>
                    {type_key}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {storageType === "coldStorage" ? (
              <TextField
                margin="normal"
                required
                fullWidth
                name="txtamount"
                label="Electricty Used (kW/hr)"
                type="number"
                id="txtamount"
                value={electricity}
                onChange={(event) => {
                  setElectricity(event.target.value);
                }}
              />
            ) : null}

            <TextField
              margin="normal"
              required
              fullWidth
              name="txtamount"
              label="Storage Quality"
              type="text"
              id="txtamount"
              value={storageQuality}
              onChange={(event) => setStorageQuality(event.target.value)}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              name="txtamount"
              // label="Storage Date"
              type="date"
              id="txtamount"
              helperText="Outbound Product Date"
              value={storageDate}
              onChange={(event) => setStorageDate(event.target.value)}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              name="txtamount"
              label="CO2 Emission (kgs)"
              type="number"
              id="txtamount"
              value={emission}
              InputLabelProps={{ shrink: false }}
              // onChange={event => setEmission(event.target.value)}
            />

            <Button
              style={{ marginTop: 10 }}
              variant="contained"
              size="small"
              color="primary"
              onClick={createNFT}
            >
              Create Storage
            </Button>
          </Grid>
        </div>
      </Container>
    </>
  );
}
